import React, { useEffect, useRef, useState } from "react";
import queryString from 'query-string';
import { useReactToPrint } from "react-to-print";

// reactstrap components
import { Button } from "reactstrap";


// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";

//Logos
import ImageLogo from "../../assets/img/logoSPRegula.png";
import logoFooterSPRegula from "../../assets/img/logoFooterSPRegula.png"

//Context
import { useAuth } from "../../context/auth";

export default function QrCodeLocalidadeRGG({ history }) {
    const { setLoading } = useAuth();
    const [localidades, setLocalidades] = useState([]);

    var QRCode = require('qrcode.react');

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true
    });

    const loadDados = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);
        setLoading(true);
        api_GET('ProtocoloGerador/ByNumeroProtocolo/' + params.protocolo).then(result => {
            if (["Cancelado", "Pendente", "Inativo"].includes(result.data.status)) {
                if (result.data.status == "Inativo") {
                    showMessage("Aviso", "Cadastro Inativo no Sistema.", 'error', null);
                    return;
                } else {
                    showMessage("Aviso", "Carteirinha não disponível", 'error', null);
                    return;
                }
            }

            let protocolo = result.data;
            if (protocolo) {
                api_GET('RGG/GetLocalidadesGeradoresTAG/' + protocolo.cpf_Cnpj).then(result => {
                    if (result.data?.length > 0 && result.data.filter(x => x.contratos.length > 0).length == 0) {
                        showMessage("Aviso", "Você não possuir contratos!", 'warning', null);
                        return;
                    }
                    setLocalidades(result.data)
                })
                    .catch(err => showMessage("Aviso", err.message, 'error', null))
                    .finally(() => setLoading(false));
            } else {
                showMessage("Error", "Error ao consultar QrCodes do contratos.", 'error', null);
                return;
            }
        })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadDados();
    }, []);

    return (
        <>
            {localidades.length > 0 && localidades.filter(x => x.contratos.length > 0).length > 0 &&
                <>
                    <style>
                        {`
                            @media print {
                                @page { 
                                    margin: 6mm 6mm 17mm 6mm;
                                }
                                .noPrint { display: none; }
                                .printItem {
                                    page-break-after: always;
                                }
                            }
                        `}
                    </style>
                    <div className="d-flex justify-content-end mt-3 noPrint">
                        <Button color="danger" onClick={handlePrint}>Imprimir QrCodes</Button>
                    </div>
                    <div className="d-flex align-items-center justify-content-center flex-column gap-4" style={{ maxWidth: "1440px", margin: "0 auto" }} ref={componentRef}>
                        {localidades.map((local, key) => (
                            local.contratos.map((contrato, keyContrato) => (
                                <div key={`${key}-${keyContrato}`} className="mt-2 py-2 printItem" style={{ flex: "1 1 45%", maxWidth: "45%" }}>
                                    <div className='d-flex align-items-center justify-content-center flex-column' id={"containerDownload"} style={{ width: "100%" }}>
                                        {!!ImageLogo && <img src={ImageLogo} alt="Logo" style={{ width: 300 }} />}
                                        <div className='p-3 d-flex align-items-center justify-content-center flex-column bg-success bg-gradient rounded'>
                                            <div className="p-3 bg-white rounded">
                                                <QRCode
                                                    value={contrato?.tag}
                                                    size="300"
                                                    logoOpacity={1}
                                                    qrStyle={"squares"}
                                                    fgColor={"#000"}
                                                    bgColor={"#fff"}
                                                    logoWidth={60}
                                                    logoheight={60}
                                                />
                                            </div>
                                            <h3 className="mt-2 text-white">{contrato.modalidade}</h3>
                                            <p className="text-white"><span className="fw-bold">Gerador: </span> {local.identificacao}</p>
                                            <p className="text-white"><span className="fw-bold">Transportador: </span> {contrato.nomeFantasiaTransportador}</p>

                                        </div>
                                        {!!logoFooterSPRegula &&
                                            <img src={logoFooterSPRegula} alt="Footer Logo" style={{ width: 300 }} />
                                        }
                                        <p className='mt-1'><span className="fw-bold">Endereço: </span> {local.logradouro}, {local.numero}, {local.bairro}{local.complemento ? ` - ${local.complemento}` : ""}, {local.cidade} - {local.uf}</p>
                                    </div>
                                </div>
                            ))
                        ))}
                    </div>
                </>
            }
        </>
    );
}